import React from 'react';
import { BiometricSettingsPage } from '@front-activerse/modules';
import { useAllSettings } from '../context/AllSettingsContext';
import biometricDescendantRoutes from '../../BiometricSettings/descendantRoutes';

const BiometricSettingsWrapper: React.FC = () => {
  const { setCurrentModule } = useAllSettings();

  // Set current module when this component mounts
  React.useEffect(() => {
    setCurrentModule('biometric-settings');
  }, [setCurrentModule]);

  return <BiometricSettingsPage descendantRoutes={biometricDescendantRoutes} />;
};

export default BiometricSettingsWrapper;
